import React from 'react'

const withFilterList = (mapFunction) => (WrappedComponent) => {
  return function (props) {
    const { data } = props
    const list = data.filter(mapFunction)
    return <WrappedComponent {...props} data={list} />
  }
}
export default withFilterList
